<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 54px; top: 60px">
      <p>Tacha la opción incorrecta.</p>
    </span>

    <p id="text01" class="textBase pageElement">
      Había una vez un rey que tenía
      <span class="selected"
        ><span ref="crossingText" class="crossable" id="crt1">diez</span> /
        <span ref="crossingText" class="crossable" id="crt2">tres</span></span
      >
      hijos.
    </p>
    <p id="text02" class="textBase pageElement">
      Sus hijos salieron a conocer el
      <span class="selected"
        ><span ref="crossingText" class="crossable" id="crt3">mar</span> /
        <span ref="crossingText" class="crossable" id="crt4">mundo</span></span
      >.
    </p>
    <p id="text03" class="textBase pageElement">
      En el camino se toparon con un
      <span class="selected"
        ><span ref="crossingText" class="crossable" id="crt5"
          >horno de ladrillos</span
        >
        /
        <span ref="crossingText" class="crossable" id="crt6"
          >hormiguero</span
        ></span
      >.
    </p>
    <p id="text04" class="textBase pageElement">
      Después, con un lago donde nadaban muchos
      <span class="selected"
        ><span ref="crossingText" class="crossable" id="crt7">patos</span> /
        <span ref="crossingText" class="crossable" id="crt8"
          >pelícanos</span
        ></span
      >.
    </p>
    <p id="text05" class="textBase pageElement">
      Finalmente encontraron un panal de
      <span class="selected"
        ><span ref="crossingText" class="crossable" id="crt9">avispas</span> /
        <span ref="crossingText" class="crossable" id="crt10">abejas</span></span
      >.
    </p>
    <p id="text06" class="textBase pageElement">
      Por la noche llegaron a un castillo
      <span class="selected">
        <span ref="crossingText" class="crossable" id="crt11">encantado</span> /
        <span ref="crossingText" class="crossable" id="crt12"
          >recien pintado</span
        ></span
      >.
    </p>
    <p id="text07" class="textBase pageElement">
      El hermano menor superó tres pruebas muy
      <span class="selected"
        ><span ref="crossingText" class="crossable" id="crt13">difíciles</span> /
        <span ref="crossingText" class="crossable" id="crt14"
          >fáciles</span
        ></span
      >.
    </p>
    <p id="text08" class="textBase pageElement">
      Los hermanos mayores
      <span class="selected"
        ><span ref="crossingText" class="crossable" id="crt15">pasaron</span> /
        <span ref="crossingText" class="crossable" id="crt16"
          >perdieron</span
        ></span
      >
      la primera prueba.
    </p>
    <p id="text09" class="textBase pageElement">
      Y así desencantó el palacio y se
      <span class="selected"
        ><span ref="crossingText" class="crossable" id="crt17">bailó</span> /
        <span ref="crossingText">casó</span></span
      >
      con la más joven de las princesas
    </p>

    <div
      class="textBubble"
      style="width: 450px; height: 120px; left: 418px; margin-top: 600px"
    >
      <div
        class="textContainer textBase center"
        style="width: 90%; height: 90%; font-size: 30px"
      >
        <p class="center">
          Ahora que lo resolviste,<br />lee el texto en voz alta.
        </p>
      </div>
      <img
        class="arrow"
        src="/pages/img/general/textBubbleArrow.svg"
        style="top: 100px; left: 360px"
      />
    </div>
    <span class="footer-page footer-read"></span>
  </div>
</template>
<style scoped>
.selected {
  color: #2bb673;
  font-size: 28px;
  z-index: 6;
}
#bg {
  position: absolute;
  left: 54px;
  top: 56px;
}
#text01 {
  position: absolute;
  left: 90px;
  top: 137px;
  font-size: 26px;
}
#text02 {
  position: absolute;
  left: 90px;
  top: 187px;
  font-size: 26px;
}
#text03 {
  position: absolute;
  left: 90px;
  top: 237px;
  font-size: 26px;
}
#text04 {
  position: absolute;
  left: 90px;
  top: 287px;
  font-size: 26px;
}
#text05 {
  position: absolute;
  left: 90px;
  top: 337px;
  font-size: 26px;
}
#text06 {
  position: absolute;
  left: 90px;
  top: 387px;
  font-size: 26px;
}
#text07 {
  position: absolute;
  left: 90px;
  top: 437px;
  font-size: 26px;
}
#text08 {
  position: absolute;
  left: 90px;
  top: 487px;
  font-size: 26px;
}
#text09 {
  position: absolute;
  width: 745px;
  left: 90px;
  top: 537px;
  font-size: 26px;
}
</style>
<script>
export default {
  methods: {
    dbId(name, option) {
      return `${this.$parent.type}-${this.$parent.page}-${name}-${option}`;
    },
    async loadOption(name, option) {
      var id = this.dbId(name, option);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      if (value.option) {
        this.crossWord(option);
      }

      console.log("option loaded: " + id + ", " + value.option);
    },
    saveOption(name, option) {
      var id = this.dbId(name, option);

      var word = document.getElementById(option);
      var c = " highlight";

      var value = word.className.includes(c);

      this.$db.options
        .put({
          id: id,
          option: value,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + value);
    },
    setupCrossText(t) {
      var words = t.innerHTML.split(" ");
      this.$refs["crossingText"].innerHTML = "";
      for (var i = 0; i < words.length; i++) {
        this.$refs["crossingText"].innerHTML +=
          '<span class="crossable" id="crt' +
          i +
          '">' +
          words[i] +
          "</span>" +
          " ";
        console.log(words[i]);
      }
      document.querySelectorAll(".crossable").forEach((item) => {
        item.addEventListener("click", () => {
          this.crossWord(item.id);
          this.saveOption("crossingText", item.id);
        });
      });
    },
    crossWord(id) {
      var word = document.getElementById(id);
      var c = " highlight";
      if (word.className.includes(c)) {
        word.className = word.className.replace(c, "");
      } else {
        word.className += c;
      }
    },
  },
  mounted() {
    this.setupCrossText(this.$refs["crossingText"]);
    document.querySelectorAll(".crossable").forEach((item) => {
      this.loadOption("crossingText", item.id);
    });
  },
};
</script>